<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "AddressForm" });
import { Form } from "../../../../components/index.js";
import FieldsetExtended from "../../components/fieldset/extended/FieldsetExtended.svelte";
import FieldsetShort from "../../components/fieldset/short/FieldsetShort.svelte";
import FieldsetBuyer from "../../components/fieldset/buyer/FieldsetBuyer.svelte";
import { createEventDispatcher } from "svelte";
import * as API from "../../services/api.js";
import { createContact } from "../../../contact/services/api.js";
import { v4 as uuid } from "uuid";
export let address = {};
export let action = "create";
export let beforeSave = () => {
};
export let organizationKey;
export let showCancel = false;
export let mode = "extended";
const DOMAIN = import.meta.env.VITE_DOMAIN;
const dispatch = createEventDispatcher();
const setOpeningTimes = () => {
    if (address.openingTimes === void 0) {
        return [];
    }
    return address.openingTimes.map((value) => ({
        ...value,
        key: uuid()
    }));
};
let openingTimes = setOpeningTimes();
const setContactKeys = () => {
    if (address.contacts === void 0) {
        return [];
    }
    return address.contacts.map((contact) => contact._.key);
};
let contactKeys = setContactKeys();
const getOpeningTimesForApi = () => openingTimes.filter((value) => value.weekDay !== void 0 && value.openingTime !== void 0 && value.closingTime !== void 0).map((value) => ({
    closingTime: value.closingTime,
    openingTime: value.openingTime,
    weekDay: value.weekDay
}));
let buyerMainContact = { type: "contact" };
const onSave = (response) => {
    if ("code" in response) {
        return;
    }
    address = response;
    dispatch("save", response);
};
const handleContactBinding = async (response) => {
    if (contactKeys.length > 0 && DOMAIN !== "buyer") {
        const KEY = { addressKey: response._.key };
        onSave(await API.updateAddress(KEY, { contactKeys }));
        return;
    }
    if (buyerMainContact.name === void 0) {
        onSave(response);
        return;
    }
    const CONTACT = await createContact({ ...buyerMainContact, organizationKey });
    if ("code" in CONTACT) {
        return;
    }
    onSave(await API.updateAddress({ addressKey: response._.key }, { contactKeys: [CONTACT._.key] }));
};
const handleUpdate = async () => {
    const OPENING_TIMES = getOpeningTimesForApi();
    const REQUEST = {
        ...address,
        contactKeys,
        openingTimes: OPENING_TIMES
    };
    onSave(await API.updateAddress({ addressKey: address._.key }, REQUEST));
};
const handleCreate = async () => {
    const OPENING_TIMES = getOpeningTimesForApi();
    const CREATED = await API.createAddress({
        ...address,
        openingTimes: OPENING_TIMES,
        organizationKey
    });
    if ("code" in CREATED) {
        onSave(CREATED);
        return;
    }
    await handleContactBinding(CREATED);
};
const onSubmit = async () => {
    await beforeSave();
    if (action === "update") {
        await handleUpdate();
        return;
    }
    await handleCreate();
};
const onCancel = () => {
    dispatch("cancel");
};
let formComponent = null;
export const submit = async () => {
    await formComponent?.submit();
};
export const reset = () => {
    formComponent?.reset();
};
export const isValid = () => {
    if (formComponent === null) {
        return false;
    }
    return formComponent.isValid();
};
</script>

<Form { onSubmit } id = { `${ action }-address` } bind:this = { formComponent }>

    <slot>

        {#if DOMAIN === 'buyer'}
            <FieldsetBuyer
                { address }
                { showCancel }
                { onCancel }
                { organizationKey }
                bind:contact = { buyerMainContact }
            />
        {:else if mode === 'extended'}
            <FieldsetExtended
                { address }
                { action }
                { showCancel }
                { organizationKey }
                bind:openingTimes
                bind:contactKeys

            />
        {:else if mode === 'short'}
            <FieldsetShort { address } { showCancel } { onCancel } />
        {/if}

    </slot>

</Form>